module.exports = __webpack_public_path__ + "files/7ab2afde8dd11f910a302537f2389929.png";